import SimpleVirtualizedVehicleList from '@/components/ui/vehicle-list/simple-virtualized-vehicle-list';
import { useVehiclesContext } from '@/contexts/vehicles-provider';
import { createFileRoute } from '@tanstack/react-router';
import { observer } from 'mobx-react-lite';

const SoldPage = observer(() => {
  const { soldVehicles, searchFilterCallback } = useVehiclesContext();
  return (
    <div>
      <SimpleVirtualizedVehicleList
        vehicleListingsData={soldVehicles}
        filterCallback={() => true}
        findInViewFilterCallback={searchFilterCallback}
        enableScope={() => {}}
      />
    </div>
  );
});

export const Route = createFileRoute('/(authenticated)/cars/sold/')({
  component: SoldPage,
});
